export default __webpack_public_path__ + "static/media/cebu-expo.d0eda68e.jpg";